import axios from 'axios'

/**
 * Extracts a human-readable error message from an API error response.
 * Checks backend response body first, then falls back to the provided default.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data
    if (data) {
      if (typeof data === 'string') return data
      if (typeof data.message === 'string' && data.message) return data.message
      if (typeof data.error === 'string' && data.error) return data.error
      if (typeof data.detail === 'string' && data.detail) return data.detail
      if (typeof data.detail?.message === 'string' && data.detail.message) return data.detail.message
    }
  }
  if (error instanceof Error && error.message && error.message !== 'Network Error') {
    return error.message
  }
  return fallback
}
